"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Cls2 = _styledComponents["default"].path.withConfig({
  displayName: "FileXml__Cls2",
  componentId: "avy920-0"
})(["fill:#fefefe;"]);

var FileXml = function FileXml(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("svg", {
    className: className,
    width: "52",
    height: "52",
    viewBox: "0 0 317.8 380.22",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M52.9,190V31.22C52.9,11.62,64.2.12,83.7.12q72.9,0,145.9-.1a8.61,8.61,0,0,1,7.4,3.4q39.45, 46.65,79.1,93.2c1.6,1.9,1.7,3.9,1.7,6.1v248.5c0,16.9-12,29-28.9,29H82.1c-17.3,0-29.1-12.1-29.1-29.7Q52.85, 270.42,52.9,190Z"
  }), _react["default"].createElement(Cls2, {
    d: "M178.6,224.92v3.7q0,62.85.1,125.8c0,3.1-.6,4.3-4,4.2-29.3-.2-58.7-.1-88-.1-9.6, 0-14.8-5.4-14.8-15.2V37.42q0-15.6,15.3-15.6c42.4,0,84.8.1,127.2-.1,3.9,0,4.4,1.3,4.4,4.7-.1,20.5-.1,41.1-.1, 61.6,0,16.8,11.3,28.2,28,28.2,16.1,0,32.3.1,48.4-.1,2.8,0,3.8.5,3.8,3.6q-.15,112.35-.1,224.5c0,8.4-5.6, 14.1-13.8,14.1-29.9.1-59.8,0-89.7.1-2.3,0-3.4-.3-3.4-3.1q.15-64.8.1-129.6a6.47,6.47,0,0,1,.4-1.3c1.2,1.1,2.3,2, 3.3,3.1,12.4,12.5,24.8,24.9,37.1,37.5,2.1,2.1,3.4,2.2,5.2-.1,2.1-2.7,6.7-4.7, 6.5-7.7-.1-2.6-4.1-4.9-6.4-7.3-16.6-16.8-33.3-33.5-49.8-50.3-2.1-2.2-3.3-2.7-5.8-.2q-27.15,27.75-54.6,55c-2.4, 2.4-2.4,3.8.1,5.8s4.4,6.5,7.3,6.3c2.4-.2,4.7-3.9,6.9-6.2,10.9-11,21.9-22,32.8-33C176,226.62,176.7,225.32,178.6, 224.92Z"
  }), _react["default"].createElement(Cls2, {
    d: "M234.1,30.62C256.3,56.82,272,73,294,98.92H249.2c-9.3,0-15.1-5.8-15.1-15Z"
  }), _react["default"].createElement("path", {
    d: "M95.8,176.72H19.2c-11.4,0-19.2-7.9-19.2-19.4V94.62C0,82.72,7.7,75,19.5,75H173c11.2,0,19.1, 7.9,19.1,19.2v63.2c0,11.3-7.9,19.2-19.1,19.2Z"
  }), _react["default"].createElement(Cls2, {
    d: "M96.1,121.22c4.3-8.7,8.4-16.8,12.3-24.9,1-2.1,2.1-3,4.5-2.9,6.1.2,6.1.1,6.1,6.4v55.7c0, 2.1-.4,2.8-2.6,2.7-6.6-.1-6.6,0-6.6-6.8v-38.3l-.5-.2c-2.3,4.7-4.9,9.4-7,14.3-1.1,2.6-2.6,3.2-5.4, 3.4-4.2.3-6.5-1-8.1-5.1a73.73,73.73,0,0,0-6.6-12.4v8.8c0,11.2-.1,22.5,0,33.8,0,2-.5,2.6-2.5,2.6-6.7-.1-6.7, 0-6.7-6.7V96.22c0-2.1.5-2.5,2.6-2.8,5-.6,7.6,1.1,9.6,5.9C88.4,106.62,92.3,113.52,96.1,121.22Z"
  }), _react["default"].createElement(Cls2, {
    d: "M41.2,117.72c4.2-7.5,8.2-14.4,12.1-21.5,1.1-2,2.3-3,4.6-2.7q3,.15,6,0c-1,2.1-2,3.7-2.9, 5.4-4.7,8.3-9.4,16.7-14.2,25a3.45,3.45,0,0,0,0,4.1c5.3,9.1,10.4,18.3,15.6,27.5.5.8.9,1.6,1.5,2.8-2.8, 0-5.3-.1-7.7,0-1.5.1-1.9-1.1-2.4-2-3.6-6.3-7.2-12.7-10.8-19-.5-.9-1.1-1.8-1.9-3.1-1.2,2.1-2.3,3.8-3.3,5.6-3, 5.3-6.1,10.6-9,16-1,1.9-2.1,2.7-4.2,2.5a58,58,0,0,0-5.9,0,5.51,5.51,0,0,1,1.1-2.8c5.2-9.2,10.3-18.4, 15.6-27.5a3.45,3.45,0,0,0,0-4.1c-5.3-9.1-10.4-18.3-15.6-27.5-.5-.8-.9-1.6-1.5-2.8,2.8,0,5.3.1,7.7,0,1.5-.1,1.9, 1.1,2.4,2,3.6,6.3,7.2,12.7,10.8,19A18.61,18.61,0,0,1,41.2,117.72Z"
  }), _react["default"].createElement(Cls2, {
    d: "M128.1,125.92v-30c0-1.9.5-2.4,2.4-2.4,6.8,0,6.8-.1,6.8,6.8v45.9c0,2.2.4,2.9,2.8,2.9, 10.5-.1,20.9,0,31.5-.1,2,0,2.5.5,2.5,2.6-.1,6.7,0,6.7-6.6,6.7-12.2,0-24.4-.1-36.6,0-2.1,0-2.7-.4-2.7-2.7C128.2, 145.72,128.1,135.82,128.1,125.92Z"
  }));
};

FileXml.displayName = 'FileXml';
FileXml.propTypes = {
  className: _propTypes["default"].string
};
FileXml.defaultProps = {
  className: ''
};
var _default = FileXml;
exports["default"] = _default;